import React, { Component } from 'react'
import Icon from '@mdi/react'
import { mdiClose, mdiBellRingOutline, mdiCheckCircleOutline, mdiAlertOutline, mdiInformationOutline } from '@mdi/js'

/**
 * Toast discreto UDV: entra desde la izquierda, anclado arriba
 * (no tapa el explorer de miniaturas abajo/derecha).
 */
class UdvGatewayToast extends Component {
  toneFromMessage = (msg, tone) => {
    if (tone) return tone
    const s = String(msg || '').toLowerCase()
    if (/error|falló|failed|sin study/.test(s)) return 'danger'
    if (/recibido|guardado|reemplazado|mantenido/.test(s)) return 'success'
    if (/recibiendo|descargando|abriendo/.test(s)) return 'progress'
    if (/ya en storage|duplicado|incompleto|avis/.test(s)) return 'warn'
    return 'info'
  }

  iconFor = (tone) => {
    if (tone === 'success') return mdiCheckCircleOutline
    if (tone === 'danger' || tone === 'warn') return mdiAlertOutline
    if (tone === 'progress') return mdiBellRingOutline
    return mdiInformationOutline
  }

  render() {
    const { open, message, onClose, onOpenNotices } = this.props
    const tone = this.toneFromMessage(message, this.props.tone)
    const sticky = /recibiendo|descargando/i.test(String(message || ''))

    return (
      <div
        className={`udv-toast-rail${open && message ? ' is-visible' : ''}`}
        aria-live="polite"
        aria-atomic="true"
      >
        <div className={`udv-toast udv-toast--${tone}${open && message ? ' is-in' : ''}`}>
          <span className="udv-toast-icon" aria-hidden>
            <Icon path={this.iconFor(tone)} size={0.85} />
          </span>
          <div className="udv-toast-body">
            <div className="udv-toast-label">TJS Gateway</div>
            <div className="udv-toast-msg">{message || ''}</div>
          </div>
          {typeof onOpenNotices === 'function' && (
            <button
              type="button"
              className="udv-toast-link"
              onClick={onOpenNotices}
              title="Ver avisos"
            >
              Ver
            </button>
          )}
          {!sticky && (
            <button
              type="button"
              className="udv-toast-dismiss"
              onClick={onClose}
              aria-label="Cerrar aviso"
            >
              <Icon path={mdiClose} size={0.7} />
            </button>
          )}
        </div>
      </div>
    )
  }
}

export default UdvGatewayToast
